import { createSelector } from '@reduxjs/toolkit';
import { MEDIA_ASSET_STATUS } from '@socialive/common';
import { selectUploads } from '@socialive/uploads';
import selectMediaUploadAssets from './selectMediaUploadAssets';

const COMPLETED_STATES = [MEDIA_ASSET_STATUS.COMPLETED, MEDIA_ASSET_STATUS.FAILED];

export default createSelector(selectMediaUploadAssets, selectUploads, (assetsMap, uploadsMap) =>
  Object.entries(assetsMap).map(([sessionHash, asset]) => {
    const upload = uploadsMap[sessionHash];

    return {
      ...upload,
      ...asset,
      isUploading: !!upload,
      isProcessing: upload?.uploaded && !COMPLETED_STATES.includes(asset?.status),
      failed: asset?.status === MEDIA_ASSET_STATUS.FAILED,
    };
  })
);
